import React from 'react'
import Reflux from 'reflux'
import { Row, Col } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeDetailsYield extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = ['yield']
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		return (
			this.state.yield !== ''
			&& this.state.yield !== null
		)
			? (
				<Row>
					<Col xs={12} style={{ padding: '1em' }}>
						<strong>
							Yield:
						</strong>
						{' '}
						{this.state.yield}
					</Col>
				</Row>
			)
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/yield.jsx